export const elementByKey = new WeakMap();
//# sourceMappingURL=element-by-key.js.map